import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import * as React from "react";
import { EnumerationCell } from "../../../../Layout/Grid/Cell/Default/EnumCell";
import { GridRowClickProps } from "../../../../Layout/Grid/GridRowClickProps";
import { validationItemUpdateModeAsString } from "../../ValidationItemUpdateMode";

export function UpdateModeEnumCell(props: GridCellProps & GridRowClickProps) {
  return <EnumerationCell {...props} mapping={validationItemUpdateModeAsString} />;
}

export const updateModeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { UpdateMode: "Active" },
      { UpdateMode: "Manual" },
      { UpdateMode: "Expired" },
      { UpdateMode: "Expired Manual" },
    ]}
    searchBox={() => null}
    {...props}
  />
);
